import styled from "styled-components";

export const StyledSidebar = styled.div`
  width: 100%;
  padding: 40px;
  border-radius: 8px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: var(--hero-background);
  filter: drop-shadow(0px 10px 8px rgba(0, 0, 0, 0.16));
  color: var(--hero-text);

  @media only screen and (max-width: 768px) {
    gap: 16px;
  }
  @media (min-width: 1024px) {
    max-width: 540px;
  }
`;
export const WrapperForm = styled.div`
  width: 100%;
`;

export const StyledSidebarTitle = styled.div`
  font-size: 22px;
  line-height: 24px;
  font-weight: 600;
  color: var(--text);

  @media only screen and (max-width: 768px) {
    font-size: 18px;
    line-height: 22px;
  }
`;
export const StyledSidebarText = styled.div<{ fontSize?: string }>`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5em;
  margin-bottom: 40px;

  @media screen and (max-width: 768px) {
    font-size: ${({ fontSize = 14 }) => fontSize};
  }
`;
export const StyledPhoneNumber = styled.div`
  font-size: 16px;
  line-height: 1.5em;
  font-weight: 600;
  @media only screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

export const StyledSidebarLink = styled.a`
  color: var(--text);
`;
